import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_SEVERITY, ErrorDCR } from '@ddt-web/config';

import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

@Injectable()
export class HttpErrorHandlerService extends AbstractErrorHandlerService {
	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error): void {
		if (error instanceof HttpErrorResponse || error.rejection instanceof HttpErrorResponse) {
			this.errorMessage = this.contentService.get('COMMON_ERROR', ErrorDCR.COMMON_ERROR);
			this.errorSeverity = ERROR_SEVERITY.CRITICAL;
			this.trackErrorMessage = 'unabletoprocessrequest';
			this.actionMessage = this.contentService.get('ERROR_RETRY_MESSAGE', ErrorDCR.ERROR_RETRY_MESSAGE);
			this.actionLabel = this.contentService.get('ERROR_RETRY_LABEL', ErrorDCR.ERROR_RETRY_LABEL);
			this.httpRequestId = error?.headers?.get('x-request-id');
			console.error('There was an HTTP error. Status code:', error.status || error.responseJson?.status, error);
			if (error.status === 401) {
				this.errorMessage = this.contentService.get('UNAUTHORIZED_ERROR', ErrorDCR.UNAUTHORIZED_ERROR);
				this.errorSeverity = ERROR_SEVERITY.WARNING;
				this.trackErrorMessage = 'sessionexpired';
				this.actionMessage = this.contentService.get('ERROR_LOGIN_MESSAGE', ErrorDCR.ERROR_LOGIN_MESSAGE);
				this.actionLabel = this.contentService.get('ERROR_LOGIN_LABEL', ErrorDCR.ERROR_LOGIN_LABEL);
			}
			this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);
			this.errorPopupService.openResponseMessageDialog(this.buildErrorMessage(), true);
		} else {
			this.nextHandler.handleError(error);
		}
	}
}
